import React from "react";
import { Stack, Box, Typography } from "@mui/material";

/**
 * 3 mini-counters para el panel de tareas: Due Today, Overdue, Done Today.
 */
export default function TaskStats({ stats }) {
  const items = [
    { label: "Due Today", value: stats?.dueToday || 0, color: "#D97706", bg: "#FEF3C7" },
    { label: "Overdue", value: stats?.overdue || 0, color: "#DC2626", bg: "#FEE2E2" },
    { label: "Done Today", value: stats?.completedToday || 0, color: "#16A34A", bg: "#DCFCE7" },
  ];

  return (
    <Stack direction="row" spacing={1}>
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            flex: 1,
            p: 1,
            borderRadius: 1.5,
            bgcolor: item.bg,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" fontWeight={800} sx={{ color: item.color, lineHeight: 1.1 }}>
            {item.value}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: "0.6rem", color: item.color }}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
